<template>
  <v-app-bar :clipped-left="$vuetify.breakpoint.lgAndUp" app color="primary darken-4" dark>
    <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
    <v-toolbar-title class="ml-0">
      <template v-if="$route.name === 'orders.detail'">
        <v-btn color="grey darken-2" class="mr-5" :to="{ name: 'orders' }">
          {{ $vuetify.lang.t('$vuetify.close') }}
        </v-btn>
      </template>
      <div v-else class="d-flex">
        <div class="logo"></div>
        <div class="shop-name">{{ this.$vuetify.lang.t('$vuetify.labels.shop') }}</div>
      </div>
    </v-toolbar-title>

    <v-spacer></v-spacer>

    <div>
      <div class="d-flex align-center">
        <v-btn class="action-button" color="transparent">
          <a href="https://www.penguinbox.tech/vydejna/" target="_blank" class="color-white text-decoration-none">
            <v-icon>$vuetify.icons.box</v-icon>
          </a>
        </v-btn>
        <v-menu open-on-hover offset-y>
          <template v-slot:activator="{ on }">
            <v-btn class="primary" v-on="on">
              <span v-if="me">
                <v-icon left>$vuetify.icons.user</v-icon>
                {{ me.firstName }} {{ me.lastName }}
                <v-icon right>$vuetify.icons.expand</v-icon>
              </span>
              <div v-else class="d-flex align-center justify-center h-100">
                <v-progress-circular :size="25" color="white" indeterminate :width="3" />
              </div>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="TableStateManager.resetAllTableStates">
              <v-list-item-title>{{ this.$vuetify.lang.t('$vuetify.labels.clearMetadata') }}</v-list-item-title>
            </v-list-item>
            <v-list-item @click="logout">
              <v-list-item-title>{{ this.$vuetify.lang.t('$vuetify.labels.logout') }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </div>
  </v-app-bar>
</template>

<script>
import { mapGetters } from 'vuex';
import { OrdersApiService } from '../../common/services/orders.api.service';
import { OrderModel } from '../../common/models/order.model';
import TableStateManager from '../../common/helpers/tableStateManager';

export default {
  data() {
    return {
      drawer: false,
      qrCodeReaderShow: false,
      searchItems: [],
      searchTimer: null,
      searchQuery: null,
      select: null,
      loading: false,
      TableStateManager,
    };
  },

  computed: {
    ...mapGetters('auth', { me: 'getUser' }),
  },

  watch: {
    drawer(val) {
      this.$emit('drawer-changed', val);
    },

    searchQuery() {
      clearTimeout(this.searchTimer);

      this.searchTimer = setTimeout(() => {
        this.fetchItems();
      }, 500);
    },
  },

  methods: {
    clear() {
      this.searchQuery = null;
    },

    fetchItems() {
      if (!this.searchQuery || typeof this.searchQuery !== 'string') {
        return;
      }

      OrdersApiService.getAll(builder => {
        const parsedSearchQuery = parseInt(this.searchQuery, 10);

        if (!parsedSearchQuery) {
          builder.whereContains([OrderModel.ATTR_NAME, OrderModel.ATTR_EMAIL], this.searchQuery);
        } else {
          builder.whereEquals([OrderModel.ATTR_ID], parsedSearchQuery);
        }
      }).then(response => {
        this.searchItems = response.getItems();
      });
    },

    logout() {
      this.$router.push({ name: 'logout' });
    },

    _redirectToOrder(item) {
      this.select = null;
      this.searchItems = [];
      this.searchQuery = null;
      this.$refs.autocomplete.blur();
      this.$router.push({ name: 'orders.detail', params: { id: item.id } });
    },
  },
};
</script>

<style lang="scss">
.logo {
  background: url('../../assets/simplo-shop-negative.svg') no-repeat center/100%;
  height: 35px;
  width: 100px;
}

.shop-name {
  margin-top: 19px;
  margin-left: -21px;
  font-size: 12px;
  line-height: 1;
}
</style>
